import { setIncompleteProfileModal } from '../../store/workspace/slice';
import { selectUserAttributes } from '../../store/workspace/selectors';
import { setAccessToProtectedRoutes } from '../../store/auth/slice';
import { useDispatch, useSelector } from '../../store/store';
import { IncompleteProfileIcon } from '../../assets/icons';
import { selectUserId } from '../../store/auth/selectors';
import { logOutThunk } from '../../store/auth/thunks';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';
import {
    setUserEmail,
    setSignUpStep,
    setSignUpUserId,
    setUserPhoneNumber,
} from '../../store/signUp/slice';

export default function IncompleteProfile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = useSelector(selectUserId);
    const userAttributes = useSelector(selectUserAttributes);

    const next = () => {
        dispatch(setSignUpStep('employerInfo'));
        dispatch(setAccessToProtectedRoutes(true));
        dispatch(setIncompleteProfileModal(false));
        dispatch(setSignUpUserId(userId || undefined));
        dispatch(setUserEmail(userAttributes?.email));
        dispatch(setUserPhoneNumber(userAttributes?.phone_number));
        navigate('/signup');
    };

    return (
        <Modal
            size='lg'
            title='Incomplete Profile'
            childClassName={styles.wrapper}
            icon={<IncompleteProfileIcon />}
        >
            <h3 className={styles.text}>For access to your account, please complete the sign up process.</h3>
            <Button type='Primary' text='Start Process' onClick={next} />
            <Button type='Error' text='Sign Out From Account' onClick={() => dispatch(logOutThunk())} />
        </Modal>
    )
}
